import { ParamOrganizationSlug, ParamProjectSlug, ParamRegionUrl } from "./schema-DKEjeVqP.js";
import { defineTool } from "./define-SD6AQa4b.js";
import { apiServiceFromContext } from "./api-EaEPyKlQ.js";
import { structuredResult } from "./results-NF1RJbDZ.js";
import { z } from "zod";
import { setTag } from "@sentry/core";

//#region src/tools/catalog/find-dsns.ts
const findDsnsOutputSchema = z.object({ dsns: z.array(z.object({
	id: z.string(),
	name: z.string(),
	dsn: z.string()
})) });
var find_dsns_default = defineTool({
	name: "find_dsns",
	skills: ["project-management"],
	requiredScopes: ["project:read"],
	description: [
		"List all Sentry DSNs for a specific project.",
		"",
		"Use this tool when you need to:",
		"- Retrieve a SENTRY_DSN for a specific project",
		"",
		"<hints>",
		"- If the user passes a parameter in the form of name/otherName, its likely in the format of <organizationSlug>/<projectSlug>.",
		"- If only one parameter is provided, and it could be either `organizationSlug` or `projectSlug`, its probably `organizationSlug`, but if you're really uncertain you might want to call `find_organizations()` first.",
		"</hints>"
	].join("\n"),
	inputSchema: {
		organizationSlug: ParamOrganizationSlug,
		regionUrl: ParamRegionUrl.nullable().default(null),
		projectSlug: ParamProjectSlug
	},
	annotations: {
		readOnlyHint: true,
		destructiveHint: false,
		openWorldHint: true
	},
	outputSchema: findDsnsOutputSchema,
	async handler(params, context) {
		const apiService = apiServiceFromContext(context, { regionUrl: params.regionUrl ?? void 0 });
		const organizationSlug = params.organizationSlug;
		setTag("organization.slug", organizationSlug);
		setTag("project.slug", params.projectSlug);
		const clientKeys = await apiService.listClientKeys({
			organizationSlug,
			projectSlug: params.projectSlug
		});
		return structuredResult({ dsns: clientKeys.map((clientKey) => ({
			id: String(clientKey.id),
			name: clientKey.name,
			dsn: clientKey.dsn.public
		})) });
	}
});

//#endregion
export { findDsnsOutputSchema, find_dsns_default };
//# sourceMappingURL=find-dsns-DCUQXIHr.js.map